import React from "react"
import { Link } from "gatsby"

const Footer = () => {
  return (
    <footer>
      <div className='wrapper'>
        <div className='footerItems'>
          <div className='footerLinks'>
            <Link to='/'>Anasayfa</Link>
            <Link to='/hizmetler'>Hizmetler</Link>
            <Link to='/iletisim'>İletişim</Link>
          </div>
          <div className='footerSocial'>
            <Link
              to='https://www.facebook.com'
              target='_blank'
              rel='noopener noreferrer'
            >
              <img src='/facebook.png' alt='Onur Tesisat Facebook' />
            </Link>
            <Link
              to='https://www.instagram.com'
              target='_blank'
              rel='noopener noreferrer'
            >
              <img src='/instagram.png' alt='Onur Tesisat Instagram' />
            </Link>
            <Link
              to='https://twitter.com'
              target='_blank'
              rel='noopener noreferrer'
            >
              <img src='/twitter.png' alt='Onur Tesisat Twitter' />
            </Link>
          </div>
          <div className='footerCopy'>&copy; 2020 Onur Tesisat</div>
          <div>
            <Link
              className='onrgms'
              to='https://www.linkedin.com/in/onrgms/'
              target='_blank'
              rel='noopener noreferrer'
            >
              onrgms
            </Link>
          </div>
        </div>
      </div>
    </footer>
  )
}

export default Footer
